import { Routes } from '@angular/router';
import { pendingChangesGuard } from '../../../../core/guards/pending-changes.guard';

export const cicloWizardRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./step-ciclo-configurar/step-ciclo-configurar.component')
      .then(m => m.StepCicloConfigurarComponent),
    canDeactivate: [pendingChangesGuard]
  },
  {
    path: 'ajustar-calendario',
    loadComponent: () => import('./step-ciclo-calendario/step-ciclo-calendario.component')
      .then(m => m.StepCicloCalendarioComponent),
    canDeactivate: [pendingChangesGuard]
  }
];
